import React, { Component } from "react";

import Buscar from "../../components/Buscar";
// -----------Importar Componentes de Terceros------------------
// import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CarruselClasificacion from "../../components/CarruselClasificacion";


import logo from '../../assets/Imagenes/Aviso_Privacidad/Cuadros.png'
import './css/style.css'


import Logo1 from '../../assets/Imagenes/Ayuda/Logo1.png'
import Logo2 from '../../assets/Imagenes/Ayuda/Logo2.png'
import Logo3 from '../../assets/Imagenes/Ayuda/Logo3.png'
import Logo4 from '../../assets/Imagenes/Ayuda/Logo4.png'
import Logo5 from '../../assets/Imagenes/Ayuda/Logo5.png'
import Logo6 from '../../assets/Imagenes/Ayuda/Logo6.png'
import Logo7 from '../../assets/Imagenes/Ayuda/Logo7.png'
import Logo8 from '../../assets/Imagenes/Ayuda/Logo8.png'

const DataClasificacion = [
    {
        Titulo:'Set funerario',
        Imagen:Logo1
    },
    {
        Titulo:'Planes a futuro',
        Imagen:Logo2
    },
    {
        Titulo:'Conmemoración',
        Imagen:Logo3
    },
    {
        Titulo:'Traslados',
        Imagen:Logo4
    },
    {
        Titulo:'Seguimiento',
        Imagen:Logo5
    },
    {
        Titulo:'Formas de pago',
        Imagen:Logo6
    },
    {
        Titulo:'Cobertura',
        Imagen:Logo7
    },
    {
        Titulo:'Seguimiento',
        Imagen:Logo8
    },
]


class Ayuda extends Component {
  state = {
    Error: '',
    Buscar: '',
    PeticionConmemoracionesBusqueda: '',

  }
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  componentDidMount() {
    this.scrollToTop();

  }

  onChange = () => {
    console.log('Pruebas');
  }

  render() {
    return (
      <Box className='AyudaContenedor'>
        <Container sx={{ padding: '0px !important', maxWidth: '1200px !important' }}>


          <Typography variant='h1' className='TituloAyuda'>
            Ayuda
          </Typography>

          <Box className='ContenedorBusqueda'>
            <Typography className="TituloBusqueda" variant="h3">
              ¿Qué ayuda necesitas?
            </Typography>

            <Typography className="ParrafoBusqueda">
              Aquí encontrarás información útil para poder aclarar tus dudas sobre nuestros servicios.¿No encontraste lo que buscas? Contáctanos: soporte 24/7 disponible.
            </Typography>

            <Box className='ContenedorInputBusqueda'>
              <Buscar Placeholder='Escribe aquí tu duda...' Value={this.state.Buscar} Icono={true} OnChange={this.onChange} OnClickBuscar={this.PeticionConmemoracionesBusqueda} ShowTitle={false} WidthBuscador='100%' InputDistribucion={9}  ButtonDistribucion={3}/>
            </Box>

          </Box >

          <Box id='ContenedorCarrusel'>
            <Box className='row' width='720px'>
 {
              DataClasificacion.map((item,index)=>(
                <Box key={index} className='col-6  col-md-4 col-lg-3' display='flex' justifyContent='center' mb='25px'>
                                  <CarruselClasificacion Imagen={item.Imagen} Titulo={item.Titulo}/>
                </Box>
              ))
            }
            </Box>
          </Box>
        </Container>
      </Box>
    );
  }
}

export default Ayuda;

